/* ic-roast v2 — shared Wednesday roast schedule for Inheritance Coffee.
   Single source of truth consumed by the header ticker and the product-page
   roast banner. All calculations are timezone-aware in America/Chicago
   (never the visitor's clock, never a fixed UTC offset).
   Schedule: roast window Wednesday 8:00 AM–2:00 PM Central;
   order cutoff for that roast is Wednesday 8:00 AM Central.
   v2: live DD:HH:MM:SS countdown presentation, 1-second refresh.
   State logic, timezone handling, cutoffs, and targets unchanged from v1. */
(function () {
  if (window.ICRoast) return;
  var TZ = 'America/Chicago';
  var WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var dtf = new Intl.DateTimeFormat('en-US', {
    timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    weekday: 'short', hour12: false
  });
  function wall(date) {
    var p = {};
    dtf.formatToParts(date).forEach(function (x) { p[x.type] = x.value; });
    return { y: +p.year, mo: +p.month, d: +p.day, h: (+p.hour) % 24, mi: +p.minute, s: +p.second, wd: WD.indexOf(p.weekday) };
  }
  function offsetMs(date) {
    var w = wall(date);
    return Date.UTC(w.y, w.mo - 1, w.d, w.h, w.mi, w.s) - date.getTime();
  }
  /* UTC epoch (ms) at which the Chicago wall clock reads y-mo-d h:mi.
     Two-pass offset lookup keeps this correct across DST transitions. */
  function epochFor(y, mo, d, h, mi) {
    var naive = Date.UTC(y, mo - 1, d, h, mi, 0);
    var guess = naive - offsetMs(new Date(naive));
    return naive - offsetMs(new Date(guess));
  }
  function addDays(y, mo, d, n) {
    var t = new Date(Date.UTC(y, mo - 1, d + n));
    return { y: t.getUTCFullYear(), mo: t.getUTCMonth() + 1, d: t.getUTCDate() };
  }
  function getState(now) {
    now = now || new Date();
    var w = wall(now);
    var mins = w.h * 60 + w.mi;
    var status, roastStart = null, windowEnd = null, nextRoastStart;
    if (w.wd === 3 && mins < 480) {           /* Wednesday before 8:00 AM */
      status = 'preroast';
      roastStart = epochFor(w.y, w.mo, w.d, 8, 0);
      windowEnd = epochFor(w.y, w.mo, w.d, 14, 0);
      nextRoastStart = roastStart;
    } else if (w.wd === 3 && mins < 840) {    /* Wednesday 8:00 AM–1:59 PM */
      status = 'roasting';
      roastStart = epochFor(w.y, w.mo, w.d, 8, 0);
      windowEnd = epochFor(w.y, w.mo, w.d, 14, 0);
      var nx = addDays(w.y, w.mo, w.d, 7);
      nextRoastStart = epochFor(nx.y, nx.mo, nx.d, 8, 0);
    } else {                                  /* Wed 2:00 PM through Tuesday */
      status = 'waiting';
      var ahead = (3 - w.wd + 7) % 7;
      if (ahead === 0) ahead = 7;
      var nd = addDays(w.y, w.mo, w.d, ahead);
      nextRoastStart = epochFor(nd.y, nd.mo, nd.d, 8, 0);
    }
    return {
      status: status,
      roastStart: roastStart,
      windowEnd: windowEnd,
      nextRoastStart: nextRoastStart,
      cutoffPassed: status !== 'preroast',
      msToStart: roastStart !== null ? roastStart - now.getTime() : null,
      msToNextRoast: nextRoastStart - now.getTime()
    };
  }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  /* Live digital countdown: {d,h,m,s} parts, each zero-padded. */
  function parts(ms) {
    var t = Math.max(0, Math.floor((ms == null ? 0 : ms) / 1000));
    return {
      d: pad2(Math.floor(t / 86400)),
      h: pad2(Math.floor((t % 86400) / 3600)),
      m: pad2(Math.floor((t % 3600) / 60)),
      s: pad2(t % 60)
    };
  }
  function digital(ms) {
    var p = parts(ms);
    return p.d + ':' + p.h + ':' + p.m + ':' + p.s;
  }
  /* Compact legacy format kept for API compatibility (window.ICRoast.format). */
  function fmt(ms) {
    if (ms == null) return '';
    if (ms < 60000) return '1M';
    var m = Math.floor(ms / 60000);
    var d = Math.floor(m / 1440);
    var h = Math.floor((m % 1440) / 60);
    var mm = m % 60;
    if (d > 0) return d + 'D ' + h + 'H';
    if (h > 0) return h + 'H ' + (mm < 10 ? '0' : '') + mm + 'M';
    return mm + 'M';
  }
  function setText(el, t) {
    if (el.dataset.icTxt !== t) { el.textContent = t; el.dataset.icTxt = t; }
  }
  /* One-time style injection for the banner's digital timer. No animation —
     digits update numerically only, so prefers-reduced-motion needs no override. */
  var UNITS = [['d', 'Days'], ['h', 'Hours'], ['m', 'Min'], ['s', 'Sec']];
  function ensureStyle() {
    if (document.getElementById('ic-roast-timer-style')) return;
    var st = document.createElement('style');
    st.id = 'ic-roast-timer-style';
    st.textContent =
      '.ic-roast-cd__timer{display:flex;align-items:flex-start;gap:9px;margin-top:10px;font-variant-numeric:tabular-nums;}' +
      '.ic-roast-cd__cell{display:flex;flex-direction:column;align-items:center;min-width:36px;}' +
      '.ic-roast-cd__num{font-size:24px;font-weight:700;line-height:1.1;color:#D9B87A;letter-spacing:.03em;font-variant-numeric:tabular-nums;}' +
      '.ic-roast-cd__colon{font-size:19px;font-weight:700;line-height:1.4;color:rgba(217,184,122,.5);}' +
      '.ic-roast-cd__unit{font-size:9px;letter-spacing:.16em;text-transform:uppercase;color:rgba(247,244,242,.62);margin-top:4px;font-weight:600;}' +
      '@media (max-width:749px){.ic-roast-cd__num{font-size:21px;}.ic-roast-cd__cell{min-width:32px;}}';
    document.head.appendChild(st);
  }
  /* Build (once) the banner's DAYS:HOURS:MIN:SEC block; return its number nodes. */
  function ensureTimer(box) {
    var t = box.querySelector('.ic-roast-cd__timer');
    if (!t) {
      ensureStyle();
      t = document.createElement('div');
      t.className = 'ic-roast-cd__timer';
      t.setAttribute('role', 'timer');
      t.setAttribute('aria-live', 'off');
      UNITS.forEach(function (u, i) {
        if (i > 0) {
          var c = document.createElement('span');
          c.className = 'ic-roast-cd__colon';
          c.setAttribute('aria-hidden', 'true');
          c.textContent = ':';
          t.appendChild(c);
        }
        var cell = document.createElement('div');
        cell.className = 'ic-roast-cd__cell';
        var num = document.createElement('span');
        num.className = 'ic-roast-cd__num';
        num.setAttribute('data-ic-u', u[0]);
        num.textContent = '00';
        var lab = document.createElement('span');
        lab.className = 'ic-roast-cd__unit';
        lab.textContent = u[1];
        cell.appendChild(num);
        cell.appendChild(lab);
        t.appendChild(cell);
      });
      box.appendChild(t);
    }
    var nums = {};
    t.querySelectorAll('.ic-roast-cd__num').forEach(function (n) { nums[n.getAttribute('data-ic-u')] = n; });
    return nums;
  }
  function render() {
    var s = getState();
    var target = s.status === 'preroast' ? s.msToStart : s.msToNextRoast;
    /* --- Header ticker: compact, digits only, no unit labels --- */
    var labelText, tickText;
    if (s.status === 'preroast') { labelText = 'Roasting Today'; tickText = 'Starts in ' + digital(target); }
    else if (s.status === 'roasting') { labelText = 'Roasting Now'; tickText = 'Next roast ' + digital(target); }
    else { labelText = 'Next Roast · Wednesday'; tickText = digital(target); }
    document.querySelectorAll('[data-ic-roast-label]').forEach(function (el) { setText(el, labelText); });
    document.querySelectorAll('[data-ic-roast-tick]').forEach(function (el) { setText(el, tickText); });
    /* --- Product-page roast banner: headline + message + digital timer --- */
    document.querySelectorAll('[data-ic-roast-banner]').forEach(function (box) {
      var head = box.querySelector('[data-ic-roast-headline]');
      var msg = box.querySelector('[data-ic-roast-msg]');
      if (!head || !msg) return;
      var h, m;
      if (s.status === 'preroast') {
        h = 'Roast day is today';
        m = 'Order before 8 AM Central to make today’s roast. Roasting begins in:';
      } else if (s.status === 'roasting') {
        h = 'Roasting now';
        m = 'Today’s roast is underway — orders placed now roast next Wednesday. Next roast in:';
      } else {
        h = 'Next roast is Wednesday';
        m = 'Orders placed now are scheduled for our next Wednesday roast, in:';
      }
      setText(head, h);
      setText(msg, m);
      var nums = ensureTimer(box);
      var p = parts(target);
      setText(nums.d, p.d);
      setText(nums.h, p.h);
      setText(nums.m, p.m);
      setText(nums.s, p.s);
      box.hidden = false;
    });
  }
  var timer = null;
  function start() {
    render();
    if (!timer) timer = setInterval(render, 1000);
  }
  window.ICRoast = { getState: getState, format: fmt, formatDigital: digital, refresh: render };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();